/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdUnlinkedObjects =
  "/custom_objects/:type_name/:external_id/unlinked_objects" as const;
